import React from "react"

import classnames from "classnames"
import PropTypes from "prop-types"

import { AlertType } from "./alertType"
import styles from "./alerts.less"

const getTypeClass = (type) => {
  switch (type) {
    case AlertType.default:
      return null
    case AlertType.success:
      return styles.alertSuccess
    case AlertType.info:
      return styles.alertInfo
    case AlertType.warning:
      return styles.alertWarning
    case AlertType.danger:
      return styles.alertDanger
    default:
      throw "Type not supported"
  }
}

const getDismissableClass = (isDismissable) => {
  return isDismissable ? styles.alertDismissable : null
}

const Alert = ({
  type,
  isDismissable,
  onHide,
  ["data-qa"]: dataQa,
  style,
  className: classNameProperty,
  noLayout,
  children,
}) => {
  const className = classnames(
    styles.alert,
    getTypeClass(type),
    getDismissableClass(isDismissable),
    classNameProperty,
    { [styles.noLayout]: noLayout },
  )

  return (
    <div className={className} data-qa={dataQa} style={style}>
      {isDismissable ? (
        <button type="button" className={styles.close} onClick={onHide}>
          &times;
        </button>
      ) : null}
      {children}
    </div>
  )
}

Alert.propTypes = {
  type: PropTypes.string,
  isDismissable: PropTypes.bool,
}

Alert.defaultProps = {
  type: AlertType.default,
  isDismissable: false,
}

export const StatelessAlert = Alert
